/* BISMAXINAT V2 buy box: proof popups, tabs, context selects (template product.bismaxinat_v2) */
(function () {
  if (window.__bmx2) return;
  window.__bmx2 = true;

  // Texts come from product.metafields.bmx2_i18n.<lang> via <script id="bmx2-t"> (see bmx2-sheets).
  var T = {};
  function loadT() { try { var el = document.getElementById('bmx2-t'); T = el ? JSON.parse(el.textContent) || {} : {}; } catch (e) { T = {}; } }
  function t(k, vars) { var s = T[k] || k; Object.keys(vars || {}).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); }); return s; }

  // Gallery stays on image 1 while the bundle script preselects the popular package on load.
  // Only a real user interaction (tap/click/key) lets a package change move the gallery.
  var userActed = false;
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function () { userActed = true; }, { capture: true, passive: true });
  });
  if (window.customElements) {
    customElements.whenDefined('variant-selects').then(function () {
      var proto = customElements.get('variant-selects').prototype;
      ['updateMediaFromInput', 'updateMedia'].forEach(function (fn) {
        var orig = proto[fn];
        if (typeof orig !== 'function') return;
        proto[fn] = function () { if (!userActed) return; return orig.apply(this, arguments); };
      });
    });
  }
  // The automatic preselect writes ?variant=… into the address; a reload would then open on the pack image.
  // Keep the plain product URL until the visitor picks a pack themselves.
  var origReplace = history.replaceState;
  history.replaceState = function (state, title, u) {
    if (u != null && !userActed) {
      try { var url = new URL(u, location.href); url.searchParams.delete('variant'); u = url.pathname + url.search + url.hash; } catch (e) {}
    }
    return origReplace.call(history, state, title, u);
  };


  // Free-shipping threshold: automatic discount "Free Shipping", 45 EUR minimum (raised from 40 on 2026-10-19 so the
  // single 200-pack never qualifies; locally rounded 200-pack prices crossed 40 EUR in PL/HU/RO/SE/DK).
  // Shown in the visitor's currency at Shopify's market rate, rounded UP to a locally round amount.
  var FS_STEP = { PLN: 5, CZK: 50, HUF: 500, RON: 5, SEK: 10, DKK: 5, GBP: 5, BGN: 5, USD: 5, CHF: 5, NOK: 10 };
  function localThreshold() {
    try {
      var cur = window.Shopify && Shopify.currency;
      if (!cur || !cur.active || cur.active === 'EUR') return;
      var rate = parseFloat(cur.rate) || 0;
      document.querySelectorAll('.bmx2-fs[data-eur]').forEach(function (el) {
        var eur = parseFloat(el.getAttribute('data-eur'));
        // UK has its own GBP price list (Shopify reports rate 1.0); 45 EUR is just under 40 GBP.
        var raw = cur.active === 'GBP' && rate === 1 ? 40 : eur * rate;
        if (!raw) return;
        var step = FS_STEP[cur.active] || 1;
        var v = Math.ceil(raw / step) * step;
        el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur.active, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(v);
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', localThreshold); else localThreshold();
  var lastOpener = null;

  // Popups must live directly under <body>: inside the product column they are trapped below the sticky header.
  function hoist() {
    document.querySelectorAll('.bmx2-sheets').forEach(function (el) { if (el.parentNode !== document.body) document.body.appendChild(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hoist); else hoist();

  // ---- Lot data from product.metafields.pronesium.proof_lots (written by attribution/scripts/sync_pdp_proof.py) ----
  var CC = { 'Deutschland': 'de', 'Österreich': 'at', 'Frankreich': 'fr', 'Mexiko': 'mx', 'China': 'cn', 'Italien': 'it',
             'Spanien': 'es', 'Niederlande': 'nl', 'Belgien': 'be', 'Polen': 'pl', 'Schweiz': 'ch', 'USA': 'us', 'Indien': 'in' };
  var LANG = (document.documentElement.lang || 'de').toLowerCase();
  if (LANG === 'en' && location.pathname.indexOf('/en-us') !== 0) LANG = 'en-GB';
  function fmtDate(iso) {
    if (!iso) return '';
    var d = iso.split('-');
    try { return new Intl.DateTimeFormat(LANG, { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(+d[0], +d[1] - 1, +d[2])); }
    catch (e) { return d[2] + '.' + d[1] + '.' + d[0]; }
  }
  function fmtNum(n, dec) { return String(dec != null ? n.toFixed(dec) : n).replace('.', T.dec || ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function flags(list) {
    return (list || []).map(function (c) { var k = CC[c]; return (k ? '<span class="fl ' + k + '"></span> ' : '') + esc(T[c] || c); }).join(' ' + esc(T.and || '&') + ' ');
  }
  function setAll(sel, fn) { document.querySelectorAll('.bmx2 [data-f="' + sel + '"]').forEach(fn); }
  function microText(m) {
    if (!m) return '–';
    if (m.status === 'not_detected') return t('js_nd');
    if (m.status === 'traces') return t('js_traces');
    return (m.kbe_g != null ? m.kbe_g + ' ' + t('js_cfu') + ', ' : '') + t('js_below_guide');
  }

  var PROOF = null;
  function loadProof() {
    try { var el = document.getElementById('bmx2-proof'); PROOF = el ? JSON.parse(el.textContent) : null; } catch (e) { PROOF = null; }
  }

  function lotBy(id) { return PROOF && PROOF.lots.filter(function (l) { return l.lot === id; })[0]; }

  function renderLab(l) {
    var lab = l.lab || {}, m = lab.metals || {};
    ['pb', 'cd', 'hg'].forEach(function (k) {
      var v = m[k]; if (!v) return;
      var pct = v.share_of_limit_pct;
      setAll('bar-' + k, function (e) { e.style.width = Math.max(3, Math.min(100, pct)) + '%'; });
      setAll('bar-' + k + '-t', function (e) { e.textContent = (v.below_loq ? t('js_under') + ' ' : '') + pct + ' %'; });
    });
    ['pb', 'cd', 'hg', 'as'].forEach(function (k) {
      var v = m[k]; if (!v) return;
      setAll('v-' + k, function (e) {
        e.textContent = (v.below_loq ? '< ' : '') + fmtNum(v.ug_per_dose) + ' µg';
        e.setAttribute('data-tip', v.limit_ug_per_dose ? t('js_eu_max', { v: fmtNum(v.limit_ug_per_dose) }) : t('js_no_eu'));
      });
    });
    var mic = lab.micro || {}, anyTrace = false;
    ['tpc', 'ecoli', 'yeast', 'mold'].forEach(function (k) {
      if (mic[k] && mic[k].status !== 'not_detected') anyTrace = true;
      setAll('v-' + k, function (e) { e.textContent = microText(mic[k]); });
    });
    setAll('hero-micro', function (e) { e.textContent = anyTrace ? t('js_hero_below') : t('js_hero_nd'); });
    var mg = lab.magnesium;
    if (mg) {
      setAll('v-mg', function (e) { e.textContent = mg.measured_mg + ' mg'; e.setAttribute('data-tip', t('js_declared', { v: mg.declared_mg })); });
      setAll('hero-mg', function (e) { e.textContent = mg.measured_mg >= mg.declared_mg ? t('js_mg_ok') : t('js_mg_tol'); });
    }
    var sample = lab.sample_lot && lab.sample_lot !== l.lot ? t('js_sample', { lot: lab.sample_lot.split('-')[0] }) : '';
    setAll('lab-date', function (e) { e.textContent = t('js_lab_date', { date: fmtDate(lab.date) }) + sample; });
    setAll('lab-pdf', function (e) { e.href = lab.pdf || '#'; });
    setAll('dose', function (e) { if (lab.dose_g) e.textContent = fmtNum(lab.dose_g, 2); });
    setAll('ana', function (e) { if (lab.analysis_no) e.textContent = lab.analysis_no; });
  }

  function renderTp(l) {
    var map = { raw: l.raw_material, cap: l.capsule, fill: l.filling, pack: l.packaging };
    Object.keys(map).forEach(function (k) {
      var html = flags(map[k]);
      setAll('h-' + k, function (e) { e.innerHTML = html; });
      setAll('l-' + k, function (e) { e.innerHTML = html; });
    });
    var mhd = l.best_before ? t('js_mhd', { mhd: l.best_before.slice(5, 7) + '/' + l.best_before.slice(0, 4) }) : '';
    setAll('tp-date', function (e) { e.textContent = t('js_filled', { date: fmtDate(l.filled) }) + mhd; });
  }

  function renderXrd(l) {
    var x = l.xrpd || {};
    var de = (document.documentElement.lang || 'de').slice(0, 2) === 'de';
    setAll('xrpd-pdf', function (e) { e.href = (de ? x.pdf_de || x.pdf_en : x.pdf_en || x.pdf_de) || '#'; });
  }

  function render(kind, id) {
    var l = lotBy(id); if (!l) return;
    if (kind === 'lab') renderLab(l);
    if (kind === 'tp') renderTp(l);
    if (kind === 'xrd') renderXrd(l);
  }

  function initLots() {
    loadT();
    loadProof();
    if (!PROOF || !PROOF.lots || !PROOF.lots.length) return;
    document.querySelectorAll('.bmx2 select.bmx2-lot').forEach(function (sel) {
      var kind = sel.getAttribute('data-for');
      var lots = PROOF.lots.filter(function (l) { return kind !== 'xrd' || l.xrpd; });
      if (!lots.length) return;
      var cur = lots.some(function (l) { return l.lot === PROOF.current; }) ? PROOF.current : lots[0].lot;
      sel.innerHTML = lots.map(function (l) {
        return '<option value="' + l.lot + '"' + (l.lot === cur ? ' selected' : '') + '>' + esc(t('js_lot', { lot: l.lot })) + '</option>';
      }).join('');
      render(kind, cur);
      sel.addEventListener('change', function () { render(kind, sel.value); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLots); else initLots();

  function closeAll() {
    document.querySelectorAll('.bmx2 .sheet-wrap.open').forEach(function (w) { w.classList.remove('open'); });
    document.documentElement.classList.remove('bmx2-lock');
    if (lastOpener) { try { lastOpener.focus({ preventScroll: true }); } catch (e) {} }
  }

  function open(id, opener) {
    var w = document.querySelector('.bmx2 .sheet-wrap[data-sheet="' + id + '"]');
    if (!w) return;
    lastOpener = opener;
    var sb = w.querySelector('.sheet-b');
    if (sb) sb.scrollTop = 0;
    document.documentElement.classList.add('bmx2-lock');
    w.classList.add('open');
    var x = w.querySelector('button[data-close]');
    // Focus only after the slide-in finished; focusing earlier scrolls the off-screen sheet into view and makes it jump.
    if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 340);
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('.bmx2-usps .prow');
    if (row && !e.target.closest('[data-bmx2-open]')) { var go = row.querySelector('[data-bmx2-open]'); if (go) { e.preventDefault(); open(go.getAttribute('data-bmx2-open'), go); return; } }
    var o = e.target.closest('[data-bmx2-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-bmx2-open'), o); return; }
    var c = e.target.closest('.bmx2 [data-close]');
    if (c) { e.preventDefault(); closeAll(); return; }
    var t = e.target.closest('.bmx2 [data-tab]');
    if (t) {
      var L = t.closest('.sheet');
      L.querySelectorAll('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b === t)); });
      L.querySelectorAll('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== t.getAttribute('data-tab'); });
      return;
    }
    var v = e.target.closest('.bmx2 button.val');
    if (v) {
      var on = !v.classList.contains('tip');
      document.querySelectorAll('.bmx2 .val.tip').forEach(function (x) { x.classList.remove('tip'); });
      v.classList.toggle('tip', on);
      return;
    }
    var view = e.target.closest('.bmx2 [data-view]');
    if (view) {
      var chart = view.closest('[data-chart]');
      var mix = view.getAttribute('data-view') === 'mix';
      chart.classList.toggle('mixed', mix);
      chart.querySelectorAll('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === view)); });
      var cap = chart.querySelector('[data-cap]');
      if (cap) cap.textContent = mix ? t('js_cap_mix') : t('js_cap_real');
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.bmx2 .ctx-s');
    if (!sel) return;
    var out = sel.closest('.ctx').querySelector('[data-ctx]');
    var opt = sel.selectedOptions && sel.selectedOptions[0];
    out.textContent = (opt && opt.dataset.t) || T['js_ctx_' + sel.value] || out.textContent;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('.bmx2 .sheet-wrap.open')) closeAll();
  });
})();
